export const baseUrl = "https://apispinforcash.almonds.ai/api";
// export const baseUrl = "https://spin4cashv2.almonds.ai/api";
// export const baseUrl = "http://localhost:4000/api";
console.log(`Base URL: ${baseUrl}`);
